import { Link } from "react-router-dom";
import { navLinks, siteBrand } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1320px] px-5 py-16 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-flashlight-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                {siteBrand.name}
              </span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-200/80">
              {siteBrand.slogan}。我们面向知情者征集原始素材与文件，负责核实、脱敏与呈现。
            </p>
            <p className="mt-4 text-xs tracking-wide text-accent-300/90">{siteBrand.operatorLine}</p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold tracking-[0.16em] text-accent-300">站内导航</h2>
            <ul className="mt-5 space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold tracking-[0.16em] text-accent-300">投稿通道</h2>
            <ul className="mt-5 space-y-3">
              <li>
                <Link
                  to="/submit"
                  className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-accent-300"
                >
                  在线提交线索
                </Link>
              </li>
              <li>
                <Link
                  to="/guide"
                  className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-accent-300"
                >
                  投稿指南
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-accent-300"
                >
                  常见问题
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${siteBrand.email}`}
                  className="cursor-pointer break-all text-sm text-background-200/85 transition-colors hover:text-accent-300"
                >
                  加密邮箱投递
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold tracking-[0.16em] text-accent-300">联系我们</h2>
            <p className="mt-5 text-sm leading-7 text-background-200/80">
              线索邮箱
              <br />
              <a
                href={`mailto:${siteBrand.email}`}
                className="cursor-pointer break-all text-background-50 transition-colors hover:text-accent-300"
              >
                {siteBrand.email}
              </a>
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-background-50/20 px-3 py-1.5 text-xs text-background-200/85">
              <span className="amb-live-dot h-1.5 w-1.5 rounded-full bg-accent-400"></span>
              通道全天开放
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-background-50/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-6 text-background-200/70">
            © {new Date().getFullYear()} {siteBrand.fullName} · 内容以核实为准，站内示例联系方式仅供说明用途。
          </p>
          <p className="text-xs leading-6 text-background-200/70">
            我们不鼓励任何可能让你承担不可控风险的行为，安全优先于线索。
          </p>
        </div>
      </div>
    </footer>
  );
}